export enum contactViewTypes {
  CONTACT_LIST = 'contact',
  PHONE_LIST = 'phone',
  PHOTO_LIST = 'photo',
  CHECKBOX_LIST = 'checkbox',
  BIRTHDAY_LIST = 'birthday',
}
